/*
 * @Author: huangshuo
 */
<template>
  <ul
    ref="contextMenu"
    class="pop-menu"
    :style="{top: top, left: left}"
    :class="{'show-menu': menuPosition.isShow && hasFn}"
    @mouseleave="menuLeave"
    @click="contextHandler"
  >
    <li
      v-for="({name, ref, operateType, showLine}, index) in contextData"
      :id="ref"
      :key="index"
      class="sub-item"
      :data-cmd="ref"
      :data-operate-type="operateType"
      @mouseleave="leaveHandler(ref, $event)"
      @mouseenter="enterHandler(ref, $event)"
    >
      <div
        v-if="showLine"
        class="sub-item-line"
      />
      <div
        class="sub-item-content"
        :data-cmd="ref"
        :data-operate-type="operateType"
      >
        {{ $t(name) }}
      </div>
    </li>
  </ul>
</template>
<script>
import * as Util from 'js/util/util.js'

export default {
  name: 'ContextMenu',
  props: {
    menuPosition: {
      type: Object,
    },
    /**
             * 要展示的数据内容
             */
    contextData: {
      type: Array,
      default() {
        return []
      },
    },
    /** 是否展示转存  */
    isShowTransfer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      top: '0px', // 列表定位
      left: '0px', // 列表定位
    }
  },
  computed: {
    hasFn() { // 无任何操作权限时返回false
      return this.contextData.length > 0
    },
  },
  watch: {
    /**
             * 监听位置组件的变化
             */
    menuPosition: {
      handler({
        left, top, isShow, otherobj,
      }) {
        const vm = this
        this.$nextTick(() => {
          if (isShow) {
            vm.setMenuPos(left, top, vm, otherobj)
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    /**
             *根据元素data-获取元素属性
             */
    dataset(element) {
      const obj = {}
      if (element.dataset) {
        return element.dataset
      }
      for (let i = 0; i < element.attributes.length; i++) {
        const key = element.attributes[i].nodeName
        if (/^data-\S+$/.test(key)) { // 判断是否以data-开头的属性名
          const value = element.attributes[i].nodeValue// 值
          const keyName = key.match(/^data-(\S+)/)[1].replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : '')) // 键名并转驼峰
          obj[keyName] = value// 对象添加属性
        }
      }
      return obj
    },
    /**
             * 鼠标点击事件
             */
    contextHandler(e) {
      let target = e.target || e.srcElement
      const tagName = target.tagName.toLowerCase()
      if (tagName !== 'li') target = target.parentNode
      const name = this.dataset(target).cmd
      const { operateType } = this.dataset(target)

      this.$emit('operationAction', { name, operateType })
      this.menuPosition.isShow = false
    },
    /**
             * 菜单离开事件
             */
    menuLeave(e) {},
    /**
             * 鼠标进入菜单(每个元素)的触发的方法,处理含有多级菜单的情况,暂不处理
             */
    enterHandler(ref, e, hasline) {
    },
    /**
             * 鼠标离开(每个元素)触发的方法,处理含有多级菜单的情况,暂不处理
             */
    leaveHandler(ref, e) {
    },
    /**
             * 设置右键菜单的显示位置
             */
    setMenuPos(left, top, vm, otherobj) {
      // 有权限按钮，才进行计算
      if (this.hasFn) {
        if (otherobj) {
          const menudom = vm.$refs.contextMenu
          this.$nextTick(() => {
            Util.setMenuPosition(null, menudom, otherobj.pardom)
          })
          return
        }

        const elem = vm.$refs.contextMenu
        const elemH = elem ? Util.getWidthOrHeight(elem, 'height') : 0
        const elemW = elem ? Util.getWidthOrHeight(elem, 'width') : 0
        const winH = window.innerHeight || document.documentElement.clientHeight
        const winW = window.innerWidth || document.documentElement.clientWidth
        // 到浏览器顶的高和到底的长度
        const toTopH = top
        const toBottomH = winH - top
        // 整个列表的高度
        const listEl = document.getElementById('list-wrapper')
        const listH = listEl.offsetHeight
        // 此时重新算左右
        const closeEdge = left + elemW > winW
        // 计算左侧位置
        vm.left = `${closeEdge ? (left - elemW) : left}px`
        // 如果距底的的距离大于高度
        if (toBottomH > elemH) {
          // vm.top = `${top - elemH*0.25}px`
          vm.top = `${top}px`
          return
        }
        // 如果距离顶部的距离小于等于高度,比较极端
        if (toTopH <= elemH) {
          vm.top = '0px'
          return
        }
        // 如果到顶的距离小于当前菜单的高度
        if (toBottomH <= elemH) {
          vm.top = `${top - elemH}px`
          return
        }
        // 当上下都不够宽时
        if (top < elemH && toBottomH < elemH) {
          // 取当前按键到列表容器的高度
          const toLisTtopH = top - (winH - listH)
          // 比例
          const rate = toLisTtopH / listH
          const realT = Math.round(listH * rate)
          vm.top = `${top - realT}px`
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.pop-menu{
  position: fixed;
  margin: 0;
  display: none;
  list-style-type: none;
  z-index: 1000;
  min-width: 158px;
  background: #FFFFFF;
  border: 1px solid #E8EBEF;
  box-shadow: 0 4px 14px 0 rgba(5,15,40,0.10);
  border-radius: 2px;
  padding: 8px 0;
  width: 158px;
  word-break:break-all;
  &.show-menu{
    display: block;
  }

  li:first-child{
    border-top: none!important;
  }
}

//el-tooltips部分
.op-tip{
  width: 220px!important;
}
.item-content{
  width: 100%;
  height: 100%;
  display: block;
}

.sub-item {
  .sub-item-line {
    margin:8px 16px;
    border-bottom:1px solid #EAEAEA;
  }
  .sub-item-content {
    min-width: 158px;
    padding: 0px 16px;
    color: #282e3d;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 36px;
    &:hover {
      background: #F6F7FA;
    }
    .menu-item-name{
      font-size: 14px;
      color: #1B2733;
    }
    .menu-item-desc{
      color: #929ca9;
      display: block;
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
